"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _Modal = _interopRequireWildcard(require("./Modal"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ModalTransitionController = function ModalTransitionController(_ref) {
  var show = _ref.show,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["show"]);
  (0, _react.useEffect)(function () {
    if (!show) {
      document.body.className = document.body.className.replace(/ ?modal-open/, '');
    } else {
      document.body.className += document.body.className.length ? ' modal-open' : 'modal-open';
    } // clean up any open modal classes from the body before unmounting the component


    return function () {
      document.body.className = document.body.className.replace(/ ?modal-open/, '');
    };
  }, [show]);
  return _react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "modal",
    "in": show,
    timeout: 300,
    exit: false,
    unmountOnExit: true
  }, _react["default"].createElement(_Modal["default"], rest));
};

ModalTransitionController.defaultProps = _Modal.modalDefaultProps;
ModalTransitionController.propTypes = _objectSpread({
  show: _propTypes["default"].bool.isRequired
}, _Modal.modalPropTypes);
var _default = ModalTransitionController;
exports["default"] = _default;